<script>

import { Pie } from 'vue-chartjs'

export default {
  extends: Pie,
  components: {
  },
  props: ['roles'],
  name: 'RolesByProfile',
  data () {
    return {
      options: {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
          datalabels: {
            display: false
          }
        }
      },
      data: {
        datasets: [{
          data: [ 0, 0, 0 ],
          backgroundColor: ['rgba(52, 152, 219, 0.8)', 'rgba(98, 203, 49, 0.5)', 'rgba(30, 107, 10, 0.8)','rgba(125, 157, 12, 0.8)', 'rgba(85, 20, 70, 0.8)']
        }],
        labels: []
      }
    }
  },
  methods: {
    draw: function () {
      this.data.datasets[0].data = []
      let roleValue = []
      let roleLabels = []

      this.roles.forEach((role) => {
        roleLabels.push(role.name)
        roleValue.push(role.nb)
      })

      this.data.datasets[0].data = roleValue
      this.data.labels = roleLabels
      this.options.labels = roleLabels

      this.renderChart(this.data, this.options)
    }
  },
  mounted () {
    this.draw()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/RolesByProfile.vue